import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getUser } from './getUser';
export const getLastName = createSelector(getUser, get('last_name'));